import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { i18n } from './lang/index'
import {aliTranslate} from "@/api/home"; //国际化
// 定义全局方法
Vue.prototype.$aliTranslatezHtoen =  function(text) {
  return   aliTranslate({
   formatType: 'text',
   sourcelanguage: 'zh',
   sourceText: text,
   targetLanguage: 'en'
 });
};

Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')
